import { AppIcon } from './AppIcon/AppIcon';
import type { AppTooltipProps } from './AppTooltip/AppTooltip';
import { AppTooltip } from './AppTooltip/AppTooltip';

type AppTooltipInfoProps = Omit<AppTooltipProps, 'children'>;

export const AppInfoTooltip = (rest: AppTooltipInfoProps) => {
	return (
		<AppTooltip {...rest}>
			<AppIcon name={'InfoOutline'} color={'greyLight'} />
		</AppTooltip>
	);
};
